import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import { BaseResponse, ResponseStatus } from '.'

export { BaseResponse, ResponseStatus }

export interface VenueEntity {
  venueId: string
  venueCompanyId: string
  name: string
  logo: string
  latitude: number
  longitude: number
  address1: string
  address2: string
  province: string
  country: string
  email: string
  phone: string
  website: string
  openingHours: number
  closingHours: number
  currentLicenseState: string
  licenses: VenueLicenseEntity[]
}

export interface VenueCompanyEntity {
  venueCompanyId: string
  name: string
  logo: string
}

export interface VenueLicenseEntity {
  startTime: number
  endTime: number
  terminationTime: number
  state: string
}

export interface UpdateMemberHomeShopRequest {
  memberId: string
}

export class VenueAPI {
  /**
   * Set member homeshop
   * @param venueId VenueId
   * @param memberId MemberId
   * @returns {BaseResponse<VenueEntity>} API Response
   */
  public static setMemberHomeShop(
    venueId: string,
    UpdateMemberHomeShopRequest: UpdateMemberHomeShopRequest
  ): AxiosPromise<BaseResponse<VenueEntity>> {
    return axios.post(
      `/venue/v1/venues/${venueId}/member-home-shop`,
      UpdateMemberHomeShopRequest
    )
  }

  /**
   * Get Venue By company ID
   * @param venueCompanyId {string}
   * @returns {BaseResponse<VenueEntity[]>} API Response
   */
  public static getVenuesByCompanyID(
    venueCompanyId: string
  ): AxiosPromise<BaseResponse<VenueEntity[]>> {
    return axios.get(`/venue/v1/venue-companies/${venueCompanyId}/venues`)
  }

  /**
   * Get Venue Company By company ID
   * @param venueCompanyId {string}
   * @returns {BaseResponse<VenueEntity[]>} API Response
   */
  public static getVenueCompanyById(
    venueCompanyId: string
  ): AxiosPromise<BaseResponse<VenueCompanyEntity>> {
    return axios.get(`/venue/v1/venue-companies/${venueCompanyId}`)
  }
}
